export enum PermanentJobOfferDashboardStatusEnum {
    // An offer has been extended, and is awaiting a decision by the candidate.
    OfferExtendedDecisionPending = 1,
    // An offer has been accepted by the candidate, but there is no confirmed start date.
    OfferAcceptedStartDateUnconfirmed = 2,
    // An offer has been accepted, and the account manager has confirmed the start date.
    OfferAcceptedStartDateConfirmed = 3,
    // The offer was extended but was rejected by the candidate.
    OfferRejected = 4,
    // Future state, that will be set by an automated process. Cannot be set by the UI.
    AutoRejectedOfferExpired = 5,
    // An offer has been accepted, but the account manager has confirmed the candidate will not be starting.
    OfferAcceptedNotStartingConfirmed = 6
}
